import { gql, TypedDocumentNode } from "@apollo/client";

import {
  FlagNoteToSupportMutation,
  FlagNoteToSupportMutationVariables,
} from "./FlagNoteToSupport.generated";

const FLAG_NOTE_TO_SUPPORT: TypedDocumentNode<
  FlagNoteToSupportMutation,
  FlagNoteToSupportMutationVariables
> = gql`
  mutation flagNoteToSupport(
    $noteUuid: String
    $comment: String
    $customerName: String
    $email: String
    $title: String
  ) {
    flagNoteToSupport(
      noteUuid: $noteUuid
      comment: $comment
      customerName: $customerName
      email: $email
      title: $title
    ) {
      ok
    }
  }
`;

export default FLAG_NOTE_TO_SUPPORT;
